export enum LocalChannelEnum {
  all = 'ALL',
  filter = 'FILTRO',
  sell = 'VENTA',
  order = 'PEDIDO',
}
